import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "filter-group" }
const _hoisted_4 = { class: "catalogue" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "item-name" }
const _hoisted_7 = { class: "item-category" }
const _hoisted_8 = { class: "item-price" }
const _hoisted_9 = { class: "quantity-row" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "quantity-count" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", null, "GreenGrocers", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", null, " Fresh produce and everyday essentials from our sustainable online market. ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(['filter-button', { active: _ctx.activeFilter === 'All' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeFilter = 'All'))
        }, " All ", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(['filter-button', { active: _ctx.activeFilter === 'Fruit' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeFilter = 'Fruit'))
        }, " Fruit ", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(['filter-button', { active: _ctx.activeFilter === 'Vegetables' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeFilter = 'Vegetables'))
        }, " Vegetables ", 2)
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleItems, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "item-card"
        }, [
          _createVNode(_component_router_link, {
            to: { name: 'item', params: { id: String(item.id) } },
            class: "item-image-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: item.image,
                alt: item.name
              }, null, 8, _hoisted_5)
            ]),
            _: 2
          }, 1032, ["to"]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(item.category), 1),
          _createElementVNode("div", _hoisted_8, "£" + _toDisplayString(item.price.toFixed(2)), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "quantity-button",
              type: "button",
              onClick: ($event: any) => (_ctx.decrementQuantity(item.id))
            }, " − ", 8, _hoisted_10),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.localQuantity(item.id)), 1),
            _createElementVNode("button", {
              class: "quantity-button",
              type: "button",
              onClick: ($event: any) => (_ctx.incrementQuantity(item.id))
            }, " + ", 8, _hoisted_12)
          ]),
          _createElementVNode("button", {
            class: "cart-button",
            type: "button",
            onClick: ($event: any) => (_ctx.addToCart(item))
          }, " Add to cart ", 8, _hoisted_13)
        ]))
      }), 128))
    ])
  ]))
}